import { HomeService } from '@/user/apis'
import { HomeInfo } from '@/user/models/home-info'
import { map, pipe, toArray, toAsync, not, filter, isNil, reduce } from '@fxts/core'

export default {
  namespaced: true,
  state: () => ({
    primaryLectures: null,
    activatedLectures: null,
    recommendedLectures: null,
  }),
  mutations: {
    content(state, value) {
      state.primaryLectures = value
    },
    activated(state, value) {
      state.activatedLectures = value
    },
    recommend(state, value) {
      state.recommendedLectures = value
    },
  },
  actions: {
    async getPrimaryLectures({ commit }) {
      try {
        const data = await HomeService.getPrimaryLectures()
        commit('content', new HomeInfo(data))
      } catch (ignore) {
        //ignore
      }
    },
    async getActivatedLectures({ commit }) {
      try {
        const lectureCount = 1
        const lectureDataByLevel = await pipe(
          [Promise.resolve('BASIC'), Promise.resolve('INTERMEDIATE'), Promise.resolve('ADVANCE')],
          toAsync,
          map(async (level) => {
            const data = await HomeService.getActivatedLectures(level, lectureCount)

            return new HomeInfo(data).content[0]
          }),
          filter((lecture) => not(isNil(lecture))),
          toArray,
          (lectrues) =>
            reduce((acc, lecture) => ({ ...acc, [lecture.level]: lecture }), {}, lectrues)
        )

        commit('activated', lectureDataByLevel)
      } catch (ignore) {
        //ignore
      }
    },
    async getRecommendedLectures({ commit }, level) {
      try {
        const size = 12
        const lectureData = await HomeService.getActivatedLectures(level, size)

        commit('recommend', new HomeInfo(lectureData))
      } catch (ignore) {
        //ignore
      }
    },
  },
  getters: {
    primaryLectures(state) {
      return state.primaryLectures
    },
    activatedLectures(state) {
      return state.activatedLectures
    },
    recommendedLectures(state) {
      return state.recommendedLectures
    },
  },
}
